import React          from 'react'
import ReactDOM       from 'react-dom'
import BaseController from 'controllers/base'
import                     'scrollpos-styler/scrollPosStyler.js'
import CalculatorsFAQ from '../../containers/Calculators/components/CalculatorsFAQ';
import RatesPills from '../../containers/Calculators/components/RatesPills';
import {landingPageFAQs} from './faqs/calculatorsFAQs';


class Controller extends BaseController {
  call() {
    super.call();

    if (document.getElementById("faq-card")) {
      ReactDOM.render(<CalculatorsFAQ faqs={landingPageFAQs}/>, document.getElementById("faq-card"))
    }
    if (document.getElementById("rates-pills")) {
      ReactDOM.render(<RatesPills />, document.getElementById("rates-pills"))
    }
  }
}

// This adds/remove the class `navbar-collapsable-show` on the main nav


export default Controller;
